import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Cliente/editarCliente`, method: 'POST', body: values, token: token})
}